import dayjs from "dayjs";

export const MONTH_ROW_HEIGHT_PX = 336;

export const formatWeekdayName = (date: Date) => {
  return dayjs(date).format("ddd");
};

export const formatMonthCaption = (date: Date) => {
  return dayjs(date).format("MMMM YYYY");
};

export const addMonths = (base: Date, monthsToAdd: number) =>
  dayjs(base).startOf("month").add(monthsToAdd, "month").toDate();

export const monthDiffInclusive = (start: Date, end: Date) =>
  dayjs(end).startOf("month").diff(dayjs(start).startOf("month"), "month") + 1;
